import Vue from "vue";
import Router, { RouteConfig } from "vue-router";
import Home from "./views/Home.vue";
import AutoAuthPagePage from "./components/AutoAuthPage.vue";
import ErrorPage from "./components/ErrorPage.vue";
import AuthErrorPage from "./components/AuthErrorPage.vue";
import { commonRouters } from "./routers/commonRouters";
import { demoRouters } from "./routers/demoRouters";
import { env } from "@/env";

import { xsyxRouters } from "./routers/xsyxRouters";

Vue.use(Router);
const baseRouters: RouteConfig[] = [
  {
    path: "/",
    name: "home",
    component: Home,
  },
  {
    path: "*",
    component: ErrorPage,
    props: { title: "页面走丢了" },
    meta: { name: "页面走丢了" },
  },
  {
    path: "/error",
    name: "error",
    component: ErrorPage,
    meta: { name: "页面出错了" },
  },
  {
    path: "/authError",
    name: "authError",
    component: AuthErrorPage,
    meta: { name: "认证页面出错了" },
  },
  {
    path: "/autoAuth",
    name: "autoAuth",
    component: AutoAuthPagePage,
    meta: { name: "自动刷新", auth: true },
  },
];
export const vueRouterBase = env.BASE_URL;
const routers = baseRouters.concat(commonRouters).concat(demoRouters).concat(xsyxRouters);
const vueRouter = new Router({
  mode: "history",
  base: vueRouterBase,
  routes: routers,
});
export default vueRouter;
// 设置每个页面title
vueRouter.afterEach((rt: any) => {
  if (rt.meta && rt.meta.name) {
    document.title = rt.meta.name;
  }
});

vueRouter.onError((error: any) => {
  // debugger
  if ( error.errType === 'AuthError' ) {
    vueRouter.replace({
      name: "authError",
      query: {message: error.response.data, tips: error.message},
    }).then((r) => '');
  } else {
    vueRouter.replace({
      name: "error",
      query: {message: "500", tips: error.message},
    }).then((r) => '');
  }


});
